
const Items =  [
  {
    'nama': 'Rita Karlina',
    'instansi': 'Fakultas Kehutanan IPB',
    'email': 'r.karlina@yahoo.co.id',
    'feedback': 'Platform ini sangat membantu sirkulasi produk kehutanan yang lebih efektif dan efisien',
  },
  {
    'nama': 'Suhendra Santoso',
    'instansi': 'Perum Perhutani Divre III Jateng',
    'email': 'suhendra.santoso@gmail.com',
    'feedback': 'Samgat membantu untuk menghubungkan aktor-aktor dalam industri kehutanan agar saling terkait satu-sama lain',
  },
  {
    'nama': 'Ahmad Ade Wiratama',
    'instansi': 'Gapoktan Rimba Lestari',
    'email': 'wiratamaaa@gmail.com',
    'feedback': 'Kami dari Gapoktan Rimba Lestari sangat terbantu dengan adanya platform ini dan tidak khawatir lagi dengan sistem pemasaran produk.',
  },
];

const getFeedbackById = (email) => {
  return (email === undefined) ? Items[0] : Items.find(x => x.email === email);
};

const getFeedback = (limit) => {
  return (limit) ? Items.slice(0, limit) : Items;
};

export {
  Items,
  getFeedback,
  getFeedbackById
};